import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineBedroomParent, MdGroup } from "react-icons/md";
import { FaShower } from "react-icons/fa";

const ListingOverlayChild = ({ e, handleFav, handleCompare, handleRemove }) => {
  return (
    <div
      className="geodir-category-img my-4 overflow-hidden"
      style={{ borderRadius: "4px", position: "relative" }}
    >
      <Link
        to={`/details/${e.id}`}
        className="geodir-category-img-wrap fl-wrap"
      >
        <img
          style={{
            width: "300px",
            height: "250px",
            borderRadius: "inherit",
          }}
          src={e?.listing_images[0]?.image}
          alt=""
        />
      </Link>

      <div
        onClick={() => handleFav(e.id)}
        className={
          e?.is_favourite === 1
            ? "geodir-js-favorite_btn1"
            : "geodir-js-favorite_btn"
        }
      >
        <i style={{ fontSize: "20px" }} className="fal fa-heart" />
        <span>{e?.is_favourite === 1 ? "saved" : "unsaved"}</span>
      </div>

      <div
        style={{
          position: "absolute",
          right: "12px",
          top: "12px",
          overflow: "hidden",
          borderRadius: "50%",
        }}
      >
        <img
          src={e?.host?.image}
          alt=""
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>

      <div
        style={{
          position: "absolute",
          bottom: 0,
          zIndex: 10,
          padding: "10px 20px",
          textAlign: "left",
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Add background
          borderRadius: "inherit",
        }}
      >
        <h3 className="title-sin_map" style={{ fontSize: "20px" }}>
          <Link
            to={`/details/${e.id}`}
            style={{ color: "white" }}
            className="flex"
          >
            <div className="flex items-start">
              <span className="text-sm text-white relative">$ </span>
              <span className="font-bold text-white">{e?.addi_guest_price} </span>
            </div>
            <span className="text-sm mt-2 text-white ">/Night</span>
          </Link>
        </h3>

        <div
          className="geodir-category-location"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ width: "80%" }}>
            <Link
              to={`/details/${e.id}`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <MdOutlineBedroomParent size={20} color="white" />
              <p className="text-white">{e?.no_of_bedroom}</p>
            </Link>
            <Link
              to={`/details/${e.id}`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <FaShower size={20} color="white" />
              <p className="text-white">{e?.no_of_bathroom}</p>
            </Link>
            <Link
              to={`/details/${e.id}`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <MdGroup size={20} color="white" />
              <p className="text-white">{e?.no_of_guest}</p>
            </Link>
          </div>
          {e.is_compare === 0 ? (
            <div
              onClick={() => handleRemove(e.id, e.is_compare)}
              className="btn btn-secondary"
              style={{ padding: "6px 7px" }}
            >
              Remove
            </div>
          ) : (
            <div
              onClick={() => handleCompare(e.id, e.is_compare)}
              className="btn btn-secondary"
              style={{ padding: "6px 7px" }}
            >
              Compare
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingOverlayChild;